/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:4f3289ae-c176-436e-8b68-29bc3d0899f1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_cufv9yZ2r",
    "aws_user_pools_web_client_id": "4hf6kmht3cbtd47khgr9082gpa",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://fkbcm52rzjfyrlwdvyowwub4lq.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
